exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:eagle;src:url(" + require("./fonts/eagle.eot?gzil4s") + ");src:url(" + require("./fonts/eagle.eot?gzil4s") + "#iefix) format(\"embedded-opentype\"),url(" + require("./fonts/eagle.ttf?gzil4s") + ") format(\"truetype\"),url(" + require("./fonts/eagle.woff?gzil4s") + ") format(\"woff\"),url(" + require("./fonts/eagle.svg?gzil4s") + "#eagle) format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:eagle!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-point:before{content:\"\\E90B\"}.icon-percentage:before{content:\"\\E90A\"}.icon-0:before{content:\"\\E900\"}.icon-1:before{content:\"\\E901\"}.icon-2:before{content:\"\\E902\"}.icon-3:before{content:\"\\E903\"}.icon-4:before{content:\"\\E904\"}.icon-5:before{content:\"\\E905\"}.icon-6:before{content:\"\\E906\"}.icon-7:before{content:\"\\E907\"}.icon-8:before{content:\"\\E908\"}.icon-9:before{content:\"\\E909\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/asserts/styles/icon.css
// module id = 183
// module chunks = 0